import { TooltipItem } from 'chart.js';

import { GrossRevenueGraphDataPoint } from '../../../../../../interfaces/entity-dashboard/GrossRevenueData';
import { getPriceView } from '../../../../../../../shared/utils/stringUtils';
import {
  getLabelForPeriod,
  GraphGroupBy,
} from '../../../../../../../shared/features/charts';

export const getTooltipLabel =
  (dataPoints: GrossRevenueGraphDataPoint[], groupBy: GraphGroupBy) =>
  (context: TooltipItem<'line'>): string => {
    const point = dataPoints[context.dataIndex];

    if (!point) {
      return '';
    }

    const isCurrentPeriod = context.datasetIndex === 0;
    const periodInfo = isCurrentPeriod
      ? point.currentPeriodRevenue
      : point.previousPeriodRevenue;

    const label = getLabelForPeriod(periodInfo.periodFrom, periodInfo.periodTo, groupBy);

    return `${label} : ${getPriceView(periodInfo.value)}`;
  };
